import { get, post } from '@/utils/apiBase.js';
//获取补充资质列表
const getSaleAbnormal = option => {
    return get('/apis/product/get_sale_abnormal', option)
}
//保存补充资质接口
const createAbnormalRecord = option => {
    return post('/apis/product/create_abnormal_record', option)
}
//获取订单异常处理操作日志
const getSaleAbnormalRecord = option => {
    return get('/apis/product/get_sale_abnormal_record', option)
}
export default {
    getSaleAbnormal,
    createAbnormalRecord,
    getSaleAbnormalRecord
};